<template>
  <div :class="variant === 'icon' ? 'contents' : 'w-full'">
    <button
      v-if="variant === 'icon'"
      type="button"
      class="inline-flex size-9 items-center justify-center rounded-lg text-muted transition-colors hover:bg-muted hover:text-highlighted"
      aria-label="Caută produse"
      @click="openSearch()"
    >
      <UIcon name="i-heroicons-magnifying-glass" class="size-5" />
    </button>

    <button
      v-else
      type="button"
      class="flex w-full items-center gap-2 rounded-xl bg-muted/80 text-left ring-1 ring-default transition-colors hover:bg-muted"
      :class="variant === 'hero'
        ? 'h-14 px-4 shadow-sm sm:h-16 sm:px-5'
        : 'h-10 px-3'"
      :aria-label="placeholder"
      @click="openSearch()"
    >
      <UIcon
        name="i-heroicons-magnifying-glass"
        class="shrink-0 text-muted"
        :class="variant === 'hero' ? 'size-5 sm:size-6' : 'size-4'"
      />
      <span
        class="min-w-0 flex-1 truncate text-muted"
        :class="variant === 'hero' ? 'text-base sm:text-lg' : 'text-sm'"
      >
        {{ placeholder }}
      </span>
      <span
        class="hidden shrink-0 items-center gap-1 text-[11px] text-dimmed sm:inline-flex"
      >
        <kbd class="rounded-md bg-default px-1.5 py-0.5 font-medium ring-1 ring-default">{{ shortcutMod }}</kbd>
        <kbd class="rounded-md bg-default px-1.5 py-0.5 font-medium ring-1 ring-default">K</kbd>
      </span>
    </button>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  variant?: 'compact' | 'hero' | 'icon'
  placeholder?: string
}>(), {
  variant: 'compact',
  placeholder: 'Caută produs...',
})

const { openSearch } = useSiteSearch()
const shortcutMod = ref('Ctrl')

onMounted(() => {
  shortcutMod.value = /Mac|iPhone|iPad/i.test(navigator.platform) ? '⌘' : 'Ctrl'
})
</script>
